var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.cls},[_vm._v(_vm._s(_vm.value ? _vm.format(_vm.value) : _vm.fallback))])
}
var staticRenderFns = []

export { render, staticRenderFns }